const Modal = new function() {
    // Selector para los modales
    const modalSelector = '[data-modal]';
    // Selector para los elementos que activan los modales
    const modalTriggerSelector = '[data-modal-target]';
    const modalBackdropSelector = '.ss-modal-backdrop';
    const closeButtonSelector = '.ss-close-button';
  
    let modals = [];
    let triggers = [];
  
    this.init = () => {
      this.setModals();
      this.setTriggers();
    };
  
    // Obtiene y almacena todos los modales presentes en el documento
    this.setModals = () => {
      modals = [];
      document.querySelectorAll(modalSelector).forEach((modal) => modals.push(modal));
    };
  
    // Obtiene y almacena todos los elementos que activan los modales
    this.setTriggers = () => {
      triggers = [];
      document.querySelectorAll(modalTriggerSelector).forEach((trigger) => triggers.push(trigger));
  
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.onTriggerClick, false);
      });
    };
  
    // Se activa al hacer clic en un elemento que activa un modal
    this.onTriggerClick = (e) => {
      e.preventDefault();
      // Busca el modal correspondiente al elemento que activó el evento
      const modalTarget = modals.find((modal) => modal.dataset.modal === e.currentTarget.dataset.modalTarget);
      this.showModal(modalTarget);
    };
  
    // Muestra el modal y configura los eventos de cierre
    this.showModal = (modal) => {
      modal.classList.add('show');
  
      const backdrop = modal.querySelector(modalBackdropSelector);
      // Función para cerrar el modal al hacer clic en el fondo (backdrop)
      const onBackdropClick = () => {
        this.closeModal(modal);
        backdrop.removeEventListener('click', onBackdropClick);
      };
      backdrop.addEventListener('click', onBackdropClick);
  
      const closeButton = modal.querySelector(closeButtonSelector);
      // Función para cerrar el modal al hacer clic en el botón de cierre
      const onCloseClick = () => {
        this.closeModal(modal);
        closeButton.removeEventListener('click', onCloseClick);
      };
      closeButton.addEventListener('click', onCloseClick);
    };
  
    // Cierra el modal ocultándolo
    this.closeModal = (modal) => {
      modal.classList.remove('show');
    };
  
    // Actualiza los elementos que activan los modales
    this.update = () => {
      this.setTriggers();
    };
};

export default Modal;
  